import { EgretLoadable } from "egret";

const TicketRatings = EgretLoadable({
  loader: () => import("./TicketRatings")
});

const Error404 = EgretLoadable({
  loader: () => import("./Error404")
});

 

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false
    },
    leftSidebar: {
      show: false,
      mode: "close"
    }
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false
    },
    navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

let userTicketLoginRoutes = [];



userTicketLoginRoutes = [
        {
          path: "/ticketratings/*",
          component: TicketRatings,
          settings
      },
        {
          path: "/Error404",
          component: Error404,
          settings
      }
];



 
export default userTicketLoginRoutes;
